import React, { useMemo } from 'react';
import * as PropTypes from 'prop-types';

import ConsentFormsList from './ConsentFormsList';
import { useInfoConsentWithAppointments } from './useInfoConsentWithAppointments';

import styles from './index.styl';

export function VisitConsents({
  noTitle,
  appointment,
  formatMessage,
  providerContext,
}) {
  const titleConsentForms = formatMessage({
    id: 'appointment.consent.title',
  });

  const {
    serviceName,
    organizationName,
    dateTime,
    allConsents,
    patientUserInfoId,
  } = useInfoConsentWithAppointments(providerContext, appointment);

  const title = useMemo(() => {
    if (noTitle) {
      return null;
    }

    return (
      <div className={styles.visitConsentsHeader}>
        <div className={styles.visitConsentsTitle}>{titleConsentForms}</div>
      </div>
    );
  }, [noTitle, titleConsentForms]);

  return (
    <div className={styles.root}>
      <ConsentFormsList
        title={title}
        serviceName={serviceName}
        organizationName={organizationName}
        dateTime={dateTime}
        allConsents={allConsents}
        patientUserInfoId={patientUserInfoId}
      />
    </div>
  );
}

VisitConsents.propTypes = {
  formatMessage: PropTypes.func,
  appointment: PropTypes.object,
  providerContext: PropTypes.bool,
  noTitle: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/index.jsx